import React from "react";

// Shared "too many devices" list used by both the standalone Login page and the
// in-app LoginModal, so the two never drift. Renders only the inner block (the
// intro line + the session rows with Remove buttons); each caller supplies its
// own container/shell and any Back/retry affordance.
export const DeviceList = ({ sessions = [], onRevoke, busy }) => (
  <>
    <p className="text-sm mb-4" style={{ color: "var(--text-secondary)" }}>You are signed in on {sessions.length} devices (max 3). Remove one to continue.</p>
    <div className="space-y-2">
      {sessions.map((s) => (
        <div key={s.jti} data-testid={`login-device-${s.jti}`} className="flex items-center justify-between px-3 py-2.5 rounded-xl" style={{ border: "1px solid var(--border-color)" }}>
          <div className="min-w-0">
            <p className="text-sm font-medium truncate" style={{ color: "var(--text-primary)" }}>{s.device_info}</p>
            <p className="text-xs" style={{ color: "var(--text-secondary)" }}>{s.location}</p>
          </div>
          <button type="button" onClick={() => onRevoke(s.jti)} disabled={busy} data-testid={`login-device-remove-${s.jti}`} className="text-xs font-medium flex-shrink-0" style={{ color: "#ef4444" }}>Remove</button>
        </div>
      ))}
    </div>
  </>
);

export default DeviceList;
